import React from "react";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="services-bg-1" />
      <div className="services-bg-2" />
      <div className="container">
        <div className="section-title">
          <h2>OUR SERVICES</h2>
          <p>
            Discover services designed to simplify complexity and accelerate growth.
          </p>
          <div className="bar" />
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
              <div key={`${d.name}-${i}`} className="col-md-4 mt">
                {" "}
                <div className="service-desc">
                  <i className={d.icon}></i>
                  <h3>{d.name}</h3>
                  <p>{d.text}</p>
                </div>
              </div>
            ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
